export default __webpack_public_path__ + "static/media/a75b39dd44f813515d2c8a2e2da6fb3c1583943509699.d69ff0bd.webp";